import { SelectAll, ShoppingBasket, Texture } from "@mui/icons-material"
import { Creators as ProfileCreators } from "model/profileModal"
import { map, size, take } from "lodash"

export function parseResults(status, data) {
  if (status !== "success" || !data) {
    return null
  }

  let equities = map(data.equities, equity => ({
    id: `${equity.exchange}.${equity.ticker}`,
    type: "security",
    label: equity.name,
    secondary: equity.country === "US" ? equity.ticker : `${equity.ticker} ${equity.country}`,
    action: ProfileCreators.openSecurityProfile,
    Icon: SelectAll,
  }))

  let swaps = map(data.swaps, swap => ({
    id: `_SWP.${swap.ticker}`,
    type: "swap",
    label: swap.name,
    secondary: swap.ticker,
    action: ProfileCreators.openSecurityProfile,
    Icon: ShoppingBasket,
  }))

  let factors = map(data.factors, factor => ({
    id: factor.id,
    type: "factor",
    label: factor.name,
    secondary: "(Factor)",
    action: ProfileCreators.openFactorProfile,
    Icon: Texture,
  }))

  const swapsToTake = Math.max(2, 10 - size(equities) - size(factors))
  swaps = take(swaps, swapsToTake)

  const factorsToTake = Math.max(3, 10 - size(equities) - size(swaps))
  factors = take(factors, factorsToTake)

  const equitiesToTake = Math.max(5, 10 - size(factors) - size(swaps))
  equities = take(equities, equitiesToTake)

  return [...equities, ...swaps, ...factors]
}
